// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.darken-col[data-v-60759f76]{\r\n\tbackground-color: rgba(0,0,0,44);\r\n\tposition: absolute;\r\n\theight: 100%;\r\n\tpadding:0;\r\n\toverflow-y:auto;\n}\n.content[data-v-60759f76]{\r\n\tmargin-bottom: 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
